import { useMutation, useQueryClient } from '@tanstack/react-query';
import { log } from '@hungryroot/o11y';
import { type CustomerAddress } from '@hungryroot/pages-checkout';
import { StatusCode, REACT_QUERY_KEYS } from '@hungryroot/rest';
import {
  postSaveShippingDay,
  type PostSaveShippingDayPayload,
} from '@hungryroot/rest/api/save_shipping_day/post';

export function usePostSaveShippingDay() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: {
      payload: PostSaveShippingDayPayload;
      data: { customerId?: number; address: CustomerAddress };
    }) => {
      const { payload } = params;
      const res = await postSaveShippingDay(payload);

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [REACT_QUERY_KEYS.ORDERS, 'order/:id/possible_days'],
      });
    },
    onError(error, variables) {
      const {
        payload,
        data: { customerId, address },
      } = variables;
      const path = '/api/save_shipping_day/';
      const data = {
        customerId,
        address,
        payload,
        path,
        error,
      };
      log('v1_save_shipping_day', data);
    },
  });
}
